var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnAlertLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7133 19.2173C26.4594 16.6902 24.4211 14.735 21.9937 14.7501C19.517 14.7654 17.4027 16.7607 17.1976 19.2909C17.0504 21.1064 16.5714 22.8039 15.5421 24.5915C15.1673 25.2423 15.1664 26.056 15.4633 26.7084C15.7559 27.3514 16.288 27.75 16.9403 27.75H27.0404C27.7005 27.75 28.2357 27.3552 28.5306 26.7299C28.8297 26.0955 28.8367 25.2995 28.4666 24.6496C27.4256 22.8219 26.9015 21.0904 26.7133 19.2173ZM21.9844 13.2501C25.2625 13.2298 27.8825 15.849 28.2058 19.0673C28.3733 20.7343 28.8339 22.2636 29.77 23.9072C30.4032 25.0189 30.3758 26.3336 29.8873 27.3696C29.3946 28.4147 28.3893 29.25 27.0404 29.25H16.9403C15.5786 29.25 14.5795 28.3878 14.098 27.3297C13.6208 26.281 13.6028 24.9534 14.2422 23.843C15.1552 22.2574 15.5722 20.7759 15.7025 19.1697C15.9683 15.8912 18.7031 13.2705 21.9844 13.2501Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11.25C22.4142 11.25 22.75 11.5858 22.75 12V13C22.75 13.4142 22.4142 13.75 22 13.75C21.5857 13.75 21.25 13.4142 21.25 13V12C21.25 11.5858 21.5857 11.25 22 11.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 30C20.75 30.6904 21.3096 31.25 22 31.25C22.6903 31.25 23.25 30.6904 23.25 30H24.75C24.75 31.5188 23.5187 32.75 22 32.75C20.4812 32.75 19.25 31.5188 19.25 30H20.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAlertLight);
export default __webpack_public_path__ + "static/media/btn_alert_light.b11c117143e34b89716d811b97273cbc.svg";
export { ForwardRef as ReactComponent };